import { z } from 'zod';

export const fixRecordSchema = z.object({
  _id: z.string(),
  repairerName: z.string(),
  content: z.string(),
  image: z.object({ name: z.string(), path: z.string() }).nullable(),
  status: z.enum(['已安排', '處理中', '已處理']),
  fixId: z.string(),
  creatorName: z.string(),
  createdTime: z.string(),
  repairedTime: z.string(),
});

export type FixRecord = z.infer<typeof fixRecordSchema>;

export const uploadFixRecordSchema = fixRecordSchema.omit({
  _id: true,
  createdTime: true,
});

export type UploadFixRecord = z.infer<typeof uploadFixRecordSchema>;
